export const volumes = [
  {
    label: 'Volume I',
    color: '#1D3F8F',
    title: 'The Perio Master Map™',
    subtitle: 'See How the Major Areas of Periodontology Connect',
    intro:
      'I created this volume to give you the big picture. Instead of looking at periodontal examination, classification, risk factors, treatment concepts, and maintenance as completely separate subjects, you’ll have a visual framework that shows how these areas relate.',
    inside: [
      'The Perio Master Clinical Map.',
      'A visual overview of the periodontal case-review process.',
      'A map of the major periodontal knowledge areas.',
      'A guide to navigating all six volumes.',
      'A glossary of essential periodontal concepts.',
      'A master reference index.',
      'A printable overview for quick consultation.',
    ],
    goal: 'Give you one visual starting point whenever you want to organize your understanding of a periodontal case.',
    note: '',
  },
  {
    label: 'Volume II',
    color: '#1F7A4A',
    title: 'The Perio Assessment Framework™',
    subtitle: 'Organize Periodontal Findings Before Drawing Conclusions',
    intro:
      'A structured review begins with understanding what information is available and what still needs to be evaluated. This volume provides an educational framework for organizing periodontal findings and documenting questions that require further review.',
    inside: [
      'A periodontal information worksheet.',
      'A clinical findings organization map.',
      'A template for recording available examination information.',
      'A periodontal assessment checklist.',
      'A framework for distinguishing observations from interpretations.',
      'An information-gap worksheet.',
      'A guide to documenting unresolved questions.',
      'Educational case examples.',
    ],
    goal: 'Help you organize the available information and identify what requires further evaluation before reaching conclusions.',
    note: 'The framework supports education and documentation. It does not diagnose patients automatically or replace a comprehensive periodontal examination.',
  },
  {
    label: 'Volume III',
    color: '#6D3FC0',
    title: 'The Perio Classification Guide™',
    subtitle: 'Connect Periodontal Classification Concepts in One Visual Reference',
    intro:
      'Periodontal classification involves terminology, categories, definitions, and criteria that need to be understood in context. I created this volume to help you organize these concepts visually rather than study them as isolated pieces of information.',
    inside: [
      'Periodontal classification concept maps.',
      'Visual terminology references.',
      'Comparison tables.',
      'Educational summaries of relevant classification criteria.',
      'Concept-relationship diagrams.',
      'Classification review worksheets.',
      'Practice questions.',
      'A visual glossary.',
      'References for further study.',
    ],
    goal: 'Help you develop a more organized understanding of periodontal classification and make your study sessions easier to navigate.',
    note: 'Classification content must be interpreted according to current professional guidance and the information available for the individual case.',
  },
  {
    label: 'Volume IV',
    color: '#D9731A',
    title: 'The Perio Risk & Complexity Map™',
    subtitle: 'Organize the Factors That May Require Closer Review',
    intro:
      'Periodontal cases can involve multiple findings, risk factors, and contextual considerations. Rather than treating each item as an isolated detail, this volume helps you organize the information and identify questions that may require further assessment.',
    inside: [
      'A periodontal risk-factor organization map.',
      'A complexity-review worksheet.',
      'A table for documenting relevant patient and case information.',
      'A framework for recording uncertainties.',
      'Educational maps connecting major periodontal concepts.',
      'A checklist for identifying information gaps.',
      'Case-review discussion prompts.',
      'A scientific reference list.',
    ],
    goal: 'Give you an organized educational reference for documenting factors that may influence case assessment and require professional consideration.',
    note: 'These resources do not replace validated risk-assessment methods or patient-specific clinical judgment.',
  },
  {
    label: 'Volume V',
    color: '#C3283F',
    title: 'The Perio Clinical Pathways™',
    subtitle: 'Structure Your Review of Different Periodontal Scenarios',
    intro:
      'Different periodontal situations require different information, different questions, and different areas of study. I created this volume to help you organize those questions into visual pathways.',
    inside: [
      'A visual overview of periodontal case-review pathways.',
      'Educational maps for organizing initial assessment information.',
      'Classification-review pathways.',
      'Risk and complexity review prompts.',
      'Treatment-planning discussion frameworks.',
      'Maintenance and follow-up information maps.',
      'Documentation prompts.',
      'Relevant educational references.',
    ],
    goal: 'Give you a consistent structure for organizing your review of different periodontal scenarios.',
    note: 'These pathways are educational frameworks. They do not prescribe patient-specific treatment or replace a comprehensive clinical evaluation.',
  },
  {
    label: 'Volume VI',
    color: '#2563B8',
    title: 'The Perio Case Review & Documentation System™',
    subtitle: 'Turn Your Periodontal Case Information Into a Clear, Organized Record',
    intro:
      'The final volume brings the previous concepts together in a practical documentation framework. I wanted to give you reusable templates that help you structure your case information and prepare educational discussions without rebuilding everything from scratch.',
    inside: [
      'A periodontal case overview worksheet.',
      'A clinical findings record.',
      'A classification-review worksheet.',
      'A risk and complexity documentation template.',
      'A treatment-objectives worksheet.',
      'A follow-up information record.',
      'A case presentation outline.',
      'A structured review checklist.',
      'A template for recording unresolved questions.',
    ],
    goal: 'Help you document and present periodontal cases in a consistent, organized format.',
    note: 'These materials are designed for education and professional organization. They do not replace official clinical records, applicable documentation requirements, or professional judgment.',
  },
];
